<div class="c-card--offer__table-header">
  @for (header of tableHeaders; track header.name; let i = $index) {
  <div class="c-card--offer__column-header" [class.-expandable]="i < 2">
    {{ header.name }}
  </div>
  }
</div>
<div class="c-card--offer__table-body">
  <ng-container *ngIf="mappedData.length > 0; else empty">
    <div *ngFor="let row of mappedData | slice : 0 : (isOpen ? mappedData.length : 3)" class="c-card--offer__table-row">
      @for (field of row; track field; let i = $index) {
      <ng-container [ngSwitch]="field.type">
        <ng-container *ngSwitchCase="'string_with_tooltip'">
          <div p500UITooltip [tooltipData]="field.value" class="c-card--offer__text-with-ellipsis" [class.-expandable]="i < 2">
            {{ field.value }}
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="c-card--offer__text-with-ellipsis" [class.-expandable]="i < 2">{{ field.value }}</div>
        </ng-container>
      </ng-container>
      }
    </div>
    <div *ngIf="mappedData.length > 3" class="c-card--offer__table-more" (click)="isOpen = !isOpen">
      <span *ngIf="isOpen" i18n="@@comomon.hide">Hide</span>
      <span *ngIf="!isOpen">+{{ mappedData.length - 3 }} <span i18n="@@common.more_offers">more offers</span></span>
    </div>
  </ng-container>
  <ng-template #empty>
    <div class="c-card--offer__table-row">
      @for (header of tableHeaders; track header.name; let i = $index) {
      <div class="c-card--offer__text-with-ellipsis" [class.-expandable]="i < 2">-</div>
      }
    </div>
  </ng-template>
</div>
